module.exports = __webpack_public_path__ + "img/SeidViroj.70bc02f7.jpg";